import Vue from "vue"
import {AclInstaller, AclCreate, AclRule} from "vue-acl"
import router from "@/router";

Vue.use(AclInstaller);

let userInfo = JSON.parse(localStorage.getItem('userInfo'));

export default new AclCreate({
    initial: userInfo ? userInfo.userRole : 'public',
    notfound: "/pages/not-authorized",
    router,
    acceptLocalRules: true,
    globalRules: {
        admin: new AclRule("admin").generate(),
        organization: new AclRule("organization").generate(),
        user: new AclRule("user").generate(),
        public: new AclRule("public").or("admin").or("organization").or("user").generate(),
        organization_user: new AclRule('organization').or("user").or('organization_branch').generate()
    }
})
